/* @flow */
import React from 'react';

import TBody from 'components/UIKit/Table/TBody';
import UploadTransactionsRow from './UploadTransactionsRow';

import type { Transactions } from 'models/transactions';

type TransactionsRowsProps = {
  children: Transactions,
  router: Object,
  projectInReview: boolean,
}

let UploadTransactionsRows = ({
  children, router, projectInReview
}: TransactionsRowsProps): React.Element => (
  TBody({
    children: children.map((transaction, i) => (
        <UploadTransactionsRow
          i={i}
          key={transaction.id}
          router={router}
          projectInReview={projectInReview}
        >
          {transaction}
        </UploadTransactionsRow>
      ))
  })
);

export default UploadTransactionsRows;
